import axios from 'axios'
import requestMixin from './requestMixin'

const baseURL = process.env.VUE_APP_BASE_API
const service = axios.create({
  baseURL,
  method: 'post',
  timeout: 30000 // request timeout
})

requestMixin(service, baseURL)

export default service
